/* tslint:disable */
/* eslint-disable */
/**
 * Lemonway DirectKit API 2.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { UltimateBeneficialOwner } from './UltimateBeneficialOwner';
import {
    UltimateBeneficialOwnerFromJSON,
    UltimateBeneficialOwnerFromJSONTyped,
    UltimateBeneficialOwnerToJSON,
} from './UltimateBeneficialOwner';

/**
 * 
 * @export
 * @interface GetUltimateBeneficialOwnerOutput
 */
export interface GetUltimateBeneficialOwnerOutput {
    /**
     * 
     * @type {Array<UltimateBeneficialOwner>}
     * @memberof GetUltimateBeneficialOwnerOutput
     */
    ultimateBeneficialOwners?: Array<UltimateBeneficialOwner>;
    /**
     * 
     * @type {Error}
     * @memberof GetUltimateBeneficialOwnerOutput
     */
    error?: Error;
}

/**
 * Check if a given object implements the GetUltimateBeneficialOwnerOutput interface.
 */
export function instanceOfGetUltimateBeneficialOwnerOutput(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function GetUltimateBeneficialOwnerOutputFromJSON(json: any): GetUltimateBeneficialOwnerOutput {
    return GetUltimateBeneficialOwnerOutputFromJSONTyped(json, false);
}

export function GetUltimateBeneficialOwnerOutputFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetUltimateBeneficialOwnerOutput {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'ultimateBeneficialOwners': !exists(json, 'ultimateBeneficialOwners') ? undefined : ((json['ultimateBeneficialOwners'] as Array<any>).map(UltimateBeneficialOwnerFromJSON)),
        'error': !exists(json, 'error') ? undefined : json['error'],
    };
}

export function GetUltimateBeneficialOwnerOutputToJSON(value?: GetUltimateBeneficialOwnerOutput | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'ultimateBeneficialOwners': value.ultimateBeneficialOwners === undefined ? undefined : ((value.ultimateBeneficialOwners as Array<any>).map(UltimateBeneficialOwnerToJSON)),
        'error': value.error,
    };
}

